var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestionWavy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CircleWavyQuestion"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.375 28.125C21.375 28.6082 20.9832 29 20.5 29C20.0168 29 19.625 28.6082 19.625 28.125C19.625 27.6418 20.0168 27.25 20.5 27.25C20.9832 27.25 21.375 27.6418 21.375 28.125Z",
    fill: "#4D7C79",
    stroke: "#4D7C79",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20.5 22.5V21.25C21.3653 21.25 22.2112 20.9934 22.9306 20.5127C23.6501 20.0319 24.2108 19.3487 24.542 18.5492C24.8731 17.7498 24.9597 16.8701 24.7909 16.0215C24.6221 15.1728 24.2054 14.3933 23.5936 13.7814C22.9817 13.1696 22.2022 12.7529 21.3535 12.5841C20.5049 12.4153 19.6252 12.5019 18.8258 12.833C18.0263 13.1642 17.3431 13.7249 16.8623 14.4444C16.3816 15.1638 16.125 16.0097 16.125 16.875M9.01562 31.4844C7.57813 30.0469 8.53125 27.0312 7.79688 25.2656C7.0625 23.5 4.25 21.9531 4.25 20C4.25 18.0469 7.03125 16.5625 7.79688 14.7344C8.5625 12.9063 7.57813 9.95312 9.01562 8.51562C10.4531 7.07813 13.4688 8.03125 15.2344 7.29688C17 6.5625 18.5469 3.75 20.5 3.75C22.4531 3.75 23.9375 6.53125 25.7656 7.29688C27.5937 8.0625 30.5469 7.07813 31.9844 8.51562C33.4219 9.95312 32.4688 12.9688 33.2031 14.7344C33.9375 16.5 36.75 18.0469 36.75 20C36.75 21.9531 33.9688 23.4375 33.2031 25.2656C32.4375 27.0937 33.4219 30.0469 31.9844 31.4844C30.5469 32.9219 27.5312 31.9688 25.7656 32.7031C24 33.4375 22.4531 36.25 20.5 36.25C18.5469 36.25 17.0625 33.4688 15.2344 32.7031C13.4063 31.9375 10.4531 32.9219 9.01562 31.4844Z",
    stroke: "#4D7C79",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionWavy);
export default __webpack_public_path__ + "static/media/question-wavy.ed99b180e3fca8dcb991721f57a58e3d.svg";
export { ForwardRef as ReactComponent };